import { render, staticRenderFns } from "./UserAlert.vue?vue&type=template&id=546f7e9c&scoped=true&"
import script from "./UserAlert.vue?vue&type=script&lang=js&"
export * from "./UserAlert.vue?vue&type=script&lang=js&"
import style0 from "./UserAlert.vue?vue&type=style&index=0&id=546f7e9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f7e9c",
  null
  
)

export default component.exports